// GENERATED — DO NOT HAND-EDIT.
//
// Source of truth: specs/tier-05-experience/event.entity-hint.yaml
// Generator: tools/v2-gen/v2gen.py
// Regenerate via: make v2-generate-screens
//
// Hand-edits to non-override-block content WILL be lost on next
// regeneration. See specs/_product/dashboard-v2-page-generator.md §5
// for override blocks (imports / helpers / header-actions).

import type { ListPageConfig } from "../../components/composition/ListPage";
import { eventsApi } from "../../api/events";
import type { Event } from "../../api/types";
// override-block:imports BEGIN
// CHG-1294 — per-page RBAC gate wiring (consumes GATE_CATALOG).
import { GATE_CATALOG } from "../../auth/gateCatalog";
import { toGate } from "../../auth/toGateProp";
// override-block:imports END

// override-block:helpers BEGIN
// override-block:helpers END

export const eventListConfig: ListPageConfig<Event> = {
  title: "Events",
  subtitle: "Calendar of giving sessions, services, and community gatherings.",
  queryKey: ["events", "list"] as const,
  queryFn: ({ page, pageSize, sortField, sortDirection, search, filters }) =>
    eventsApi.listEvents({ page, pageSize, sortField, sortDirection, search, filters }),
  defaultSort: { field: "starts_at", direction: "asc" },
  pageSize: 50,
  rowHref: "/events/{id}",
  search: { enabled: true, placeholder: "Search events by name…" },
  emptyState: {
    title: "No events yet",
    subtitle: "Create your first event to track RSVPs and coordinate communications.",
  },
  headerActions: [
    // override-block:header-actions BEGIN
    {
      // CHG-2450 (GAP-3b-ii-b) — list-level "Edit" was semantically wrong (no
      // record context) and a no-op; replaced with "New event" navigating to
      // the EventCreate route (/events/new) via PageHeaderAction.href (renders
      // a <Link>). Gated on event.create.
      id: "new",
      label: "New event",
      variant: "primary",
      href: "/events/new",
      permissionGate: toGate(GATE_CATALOG.event_list["create"], "hide"),
    },
    {
      id: "duplicate",
      label: "Duplicate",
      variant: "ghost",
      // Forward-promised — entity-hint.secondary_actions.duplicate cites the
      // duplicateEvent command, which has no backend yet (DRIFT-910 keeps it
      // deferred rather than fabricating an endpoint).
      onClick: () => undefined,
      permissionGate: toGate(GATE_CATALOG.event_list["duplicate"], "hide"),
    },
    // override-block:header-actions END
  ],
  filters: [
    { field: "designation_id", label: "Designation", type: "select", dynamicOptionsSource: "designations" },
  ],
  columns: [
    { field: "name", label: "Name", type: "text", sortable: true },
    { field: "starts_at", label: "Starts", type: "datetime", sortable: true },
    { field: "registered_count", label: "Attendees", type: "number", sortable: true },
    { field: "max_attendees", label: "Capacity", type: "number" },
    { field: "status", label: "Status", type: "text" },
  ],
};
